import React, { useState } from 'react';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import DialogActions from './DialogActions';
import { useForm, useWatch } from 'react-hook-form';
import CompanyMajorityQuestions from './Questions/CompanyMajority';
import BankQuestions from './Questions/Bank';
import LoanQuestions from './Questions/Loans';
import { contactUs } from '../../../utils';
import { submitForm } from './submitForm';

interface DialogProps {
  hasLoans: boolean;
  hasBankAccount: boolean;
  goToBankStep: (...args) => void;
  goToActivationSuccessMsg: (...args) => void;
  goToManualActivationMsg: (...args) => void;
  closeDialog: (...args) => void;
  planId: string;
}

export default function QuestionsStep({
  hasLoans,
  hasBankAccount,
  goToBankStep,
  goToActivationSuccessMsg,
  goToManualActivationMsg,
  closeDialog,
  planId,
}: DialogProps) {
  const [loading, setLoading] = useState(false);

  const { register, formState, setValue, handleSubmit, control } = useForm();
  const defaultProps = { useWatch, setValue, control };

  const onSubmit = async (params) => {
    setLoading(true);
    await submitForm({
      ...params,
      applicationId: planId,
    }).finally(() => {
      setLoading(false);
    });
    callback();
  };

  const companyMajorityAnswer = useWatch({ control, name: 'companyMajority' });
  const loansAnswer: string = useWatch({ control, name: 'loans' });
  const bankConnectionAnswer: string = useWatch({
    control,
    name: 'willConnectBank',
  });

  const ctaDisabled =
    !companyMajorityAnswer ||
    (!hasBankAccount && !bankConnectionAnswer) ||
    (hasLoans && !loansAnswer);

  const mayActivate =
    companyMajorityAnswer === 'yes' &&
    hasBankAccount &&
    (!hasLoans || loansAnswer === 'yes');

  let actionLabel = 'Activate Plan';
  let cancelLabel = 'Review Later';
  let cancelCallback = closeDialog;
  let callback = goToActivationSuccessMsg;
  if (!mayActivate) {
    actionLabel = 'Continue';
    cancelLabel = 'Contact Us';
    cancelCallback = contactUs;
    if (!hasBankAccount && bankConnectionAnswer === 'yes') {
      callback = goToBankStep;
    } else {
      callback = goToManualActivationMsg;
    }
  }
  return (
    <Dialog
      open={true}
      onClose={closeDialog}
      header="Thanks for completing e-signature!"
      description="To finish activating your plan, please confirm the following:"
      isDescriptionInHeader={true}
      maxWidth={612}
    >
      <CompanyMajorityQuestions
        {...defaultProps}
        register={register}
        errors={formState.errors}
      />
      {!hasBankAccount && <BankQuestions {...defaultProps} />}
      {hasLoans && <LoanQuestions {...defaultProps} />}
      <DialogActions
        cancelCallback={cancelCallback}
        callback={handleSubmit(onSubmit)}
        ctaDisabled={ctaDisabled}
        actionLabel={actionLabel}
        cancelLabel={cancelLabel}
        loading={loading}
      />
    </Dialog>
  );
}
